import { Flex, Heading } from "@chakra-ui/react";
import MovieCastCard, { MovieCastCardProp } from "./MovieCastCard";

interface MovieCastCardGroupedProp {
  title: string;
  allCastdetails: string[] | MovieCastCardProp[];
}

function isArrayofStrings(arr: any[]) {
  return Array.isArray(arr) && arr.every((item) => typeof item === "string");
}

function MovieCastCardGrouped({
  title,
  allCastdetails,
}: MovieCastCardGroupedProp) {
  return (
    <Flex
      mt="20px"
      background="primary.200"
      px="1rem"
      pt="1rem"
      direction={"column"}
    >
      <Heading fontSize={"1.5rem"} itemProp="genre" title="Cast" ml="1rem">
        {title}
      </Heading>
      <Flex
        gap="2rem"
        mt="1rem"
        scrollBehavior="inherit"
        overflowX="scroll"
        sx={{
          scrollbarWidth: "0.1rem",
          scrollbarHeight: "0.5px",
          scrollbarColor: "transparent transparent",
          "&:hover": {
            scrollbarColor: "auto",
          },
        }}
      >
        {isArrayofStrings(allCastdetails)
          ? (allCastdetails as string[]).map((cast) => (
              <MovieCastCard cast={cast} />
            ))
          : (allCastdetails as MovieCastCardProp[]).map(({ cast, poster }) => (
              <MovieCastCard cast={cast} poster={poster} />
            ))}
      </Flex>
    </Flex>
  );
}

export default MovieCastCardGrouped;
